import { type Entity, splitEntity } from "shelving";
import { Card, type CardProps } from "shared/react";
import { getMediaImageStyle } from "shared/util/style";
import { useItem } from "../util/db.js";

/** An `<article>` element styled with the background of profile's background, group's cover image, or reward's colour. */
export function EntityBackgroundCard({ entity, ...props }: { entity: Entity } & CardProps): React.ReactElement {
	const [type, id] = splitEntity(entity);
	if (type === "profile") return <ProfileBackgroundCard uid={id} {...props} />;
	else if (type === "group") return <GroupBackgroundCard gid={id} {...props} />;
	else if (type === "reward") return <RewardBackgroundCard id={id} {...props} />;
	else return <Card {...props} />;
}

export function ProfileBackgroundCard({ uid, ...props }: { uid: string } & CardProps): React.ReactElement {
	const { background } = useItem("profile", uid).value || {};
	return background ? <RewardBackgroundCard {...props} id={background} /> : <Card {...props} />;
}

export function GroupBackgroundCard({ gid, ...props }: { gid: string } & CardProps): React.ReactElement {
	const { cover, hue } = useItem("group", gid).value || {};
	return <Card {...props} style={getMediaImageStyle(cover, hue)} />;
}

export function RewardBackgroundCard({ id, ...props }: { id: string } & CardProps): React.ReactElement {
	const { type, image, hue } = useItem("reward", id).value || {};
	return <Card {...props} style={getMediaImageStyle(type === "background" ? image : null, hue)} />;
}
